// Enums LOCALES del dominio `retailWizard`, gemelos de los tipos de `./types.ts` y con el mismo
// TD-F2-WIZ-001: migrar a `@fiado/type-kit/bin/retailWizard` cuando la lib los publique.
//
// POR QUÉ VIVEN ACÁ Y NO SE IMPORTAN DE type-kit
// `@fiado/type-kit@3.194.0` NO trae `bin/retailWizard/` — solo retailOrg, retailCatalog y
// retailCards. Las pantallas de Ventas los importaban igual, y eso dejó el `vite build` roto desde
// el 2026-07-28 (`Rolldown failed to resolve import`): el typecheck no lo veía porque el módulo
// faltante degrada a `any`, así que el error solo aparecía al empaquetar.
//
// POR QUÉ SON OBJETOS `as const` Y NO `enum`
// El repo compila con `erasableSyntaxOnly: true` (tsconfig.app.json), que prohíbe el `enum` de
// TypeScript — por eso no hay ninguno en `src/`. El patrón objeto-congelado + tipo derivado del
// mismo nombre da lo mismo en el punto de uso: `SaleTypeEnum.CASH` como valor, `SaleTypeEnum` como
// tipo y `Object.values(...)` para recorrerlo.

/** Cómo se cerró la venta. */
export const SaleTypeEnum = {
    CASH: 'CASH',
    CREDIT: 'CREDIT',
    EXTERNAL_REFERRAL: 'EXTERNAL_REFERRAL',
} as const;
export type SaleTypeEnum = (typeof SaleTypeEnum)[keyof typeof SaleTypeEnum];

/**
 * Estado de la venta. SUBCONJUNTO conocido, no el catálogo cerrado del silo: hoy el front solo
 * necesita distinguir la cancelada del resto. Por eso los DTOs siguen tipando `status: string` —
 * que el backend sume un estado nuevo no debe romper una fila.
 */
export const SaleStatusEnum = {
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
} as const;
export type SaleStatusEnum = (typeof SaleStatusEnum)[keyof typeof SaleStatusEnum];

/**
 * Financieras de TERCEROS a las que se deriva una venta. SureKeep NO está aquí: una venta SureKeep
 * es `type: CREDIT` con `externalProvider: null`.
 */
export const ExternalProviderEnum = {
    PAYJOY: 'PAYJOY',
    CREDIYA: 'CREDIYA',
    LESPAGO: 'LESPAGO',
    INNOVA: 'INNOVA',
} as const;
export type ExternalProviderEnum = (typeof ExternalProviderEnum)[keyof typeof ExternalProviderEnum];
